import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { TotemInput } from 'components/TotemInput';
import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';
import { useCreateNayaxMdbTemplateMutation } from 'data/__generated__';

export function CreateNayaxMDBTemplatePopup({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
}) {
    const navigate = useNavigate();
    const [templateName, setTemplateName] = useState<string>('');

    const [createNayaxMDBTemplate, { loading: creationLoading }] = useCreateNayaxMdbTemplateMutation({
        variables: {
            input: {
                name: templateName,
                associations: [],
            },
        },
    });

    const handleSubmit = async () => {
        try {
            const result = await createNayaxMDBTemplate();
            if (result.data?.createNayaxMDBTemplate.success) {
                const newTemplateId = result.data.createNayaxMDBTemplate.nayaxMDBTemplate?._id;
                if (newTemplateId) {
                    toast.success('Template créé avec succès');
                    setIsOpen(false);
                    setTemplateName('');
                    navigate(`/nayax-mdb-template/${newTemplateId}`);
                } else {
                    toast.error('Une erreur est survenue lors de la création du template');
                }
            } else {
                toast.error('Une erreur est survenue lors de la création du template');
            }
        } catch (error) {
            toast.error('Une erreur est survenue lors de la création du template');
        }
    };

    return (
        <TotemPopup title="Créer un template Nayax MDB" isOpen={isOpen} setIsOpen={setIsOpen} contentOverflow="visible">
            Veuillez donner un nom unique à votre template Nayax MDB
            <SubmitContainer>
                <TotemInput
                    label="Nom du template"
                    onChange={setTemplateName}
                    placeholder="Nom"
                    value={templateName}
                    autoFocus
                />
                <TotemPrimaryLoadingButton
                    onClick={handleSubmit}
                    disabled={!templateName}
                    loading={creationLoading}
                    useIcon={false}
                    label="Confirmer"
                />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15px;

    > :not(:first-child) {
        margin-top: 15px;
    }
`;
